import { parseDate } from '@internationalized/date';

import { useDatePickerCalendar } from './Calendar/CalendarContext';
import { useDatePickerConfig } from './contexts/ConfigContext';
import { useDatePickerActions } from './Dropdown/DropdownContext';

interface PresetsProps {
  customPresets?: string[] | Record<string, string | undefined>;
  presetsDisplayGrid: number;
}

export function Presets({ customPresets, presetsDisplayGrid }: PresetsProps) {
  const { isControlled } = useDatePickerConfig();
  const { calendarState, isDateUnavailable } = useDatePickerCalendar();
  const { onClose, onCustomPresetClick, onDateChange } = useDatePickerActions();

  const display = presetsDisplayGrid > 1 ? 'grid' : 'block';

  const handlePresetClick = (label: string, value?: string) => {
    if (value) {
      try {
        const calendarDate = parseDate(value);

        const isUnavailable = calendarState.isInvalid(calendarDate);

        if (isUnavailable) {
          console.warn('Date is unavailable, skipping setValue');
          return;
        }

        if (isDateUnavailable?.(calendarDate)) {
          if (!isControlled) {
            console.warn('Date is unavailable, skipping setValue');
            return;
          }
        }

        onDateChange?.(calendarDate.toString());

        onCustomPresetClick?.(label);

        setTimeout(() => {
          onClose?.();
        }, CLOSE_DELAY_MS);
      } catch (error) {
        console.warn('Invalid date format:', value, error);
      }
    } else {
      onCustomPresetClick?.(label);
      onClose?.();
    }
  };

  if (!customPresets || customPresets.length === 0) {
    return null;
  }
  return (
    <div className="border-left presets-container">
      <div
        className="overflow-auto"
        style={{
          top: '0',
          bottom: '0',
          display: display,
          gridTemplateColumns: `repeat(${presetsDisplayGrid}, min-content)`,
        }}
      >
        {Array.isArray(customPresets)
          ? customPresets.map((preset) => (
              <button
                type="button"
                key={preset}
                onClick={() => handlePresetClick(preset)}
                className="mt-0 btn btn-link btn-lg btn-block text-left text-start"
              >
                {preset}
              </button>
            ))
          : Object.entries(customPresets).map(([label, value]) => (
              <button
                type="button"
                key={label}
                onClick={() => handlePresetClick(label, value)}
                className="mt-0 btn btn-link btn-lg btn-block text-left text-start"
              >
                {label}
              </button>
            ))}
      </div>
    </div>
  );
}

const CLOSE_DELAY_MS = 100;
